module.exports = __webpack_public_path__ + "698c51b768df8b4df76f12b8168f9a6e.jpg";